import { render } from "./ModalOffCanva.vue?vue&type=template&id=267d91e2&scoped=true"
import script from "./ModalOffCanva.vue?vue&type=script&lang=js"
export * from "./ModalOffCanva.vue?vue&type=script&lang=js"

import "./ModalOffCanva.vue?vue&type=style&index=0&id=267d91e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d91e2"]])

export default __exports__